import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';

import PageTitle from '../../../components/pageTitle';
import Navigation from '../../../components/navigation';
import BlogPost from './blogPost/ext';
import Blogs from './blogs';

const Blog = ({
  t,
  match,
  backgroundCover,
  moduleTitle,
  enableCoverColor,
  backgroundColor }) => (
    <React.Fragment>
      <PageTitle
        title={moduleTitle}
        backgroundPage={backgroundColor}
        backgroundCover={backgroundCover}
        enableCoverColor={enableCoverColor}
      />
      <section className="Blog2 boxs blog-module">
        <div className="container">
          <div className="Blog2inner boxs pdlr forlineBlog forlineBlog2">
            <div className="middleKB middlemsg">
              <Navigation />
              <Switch>
                <Route exact path={`${match.path}/post-:id`} component={BlogPost} />
                <Route
                  exact
                  path={match.path}
                  component={Blogs}
                />
                <Redirect from="*" to="/blog" />
              </Switch>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
);

Blog.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Blog;



// WEBPACK FOOTER //
// ./src/views/modules/blog/Blog.jsx